import React from "react";

const TechnologiesUsed = ({tags}) => {
    return(
        <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300 sticky top-8">
            <div className="space-y-6">
                <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-slate-900 dark:bg-slate-400 rounded-full"></div>
                    <h2 className="text-2xl font-bold text-slate-900 dark:text-white transition-colors duration-300">
                        Technologies Used
                    </h2>
                </div>
                
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-4">
                    {tags?.map((tech, index) => (
                        <div 
                            key={index}
                            className="group relative bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl p-4 hover:bg-slate-100 dark:hover:bg-slate-900 hover:scale-105 transition-all duration-300 shadow-sm"
                        >
                            <div className="flex flex-col items-center space-y-2">
                                {tech.iconUrl && (
                                    <img 
                                        src={tech.iconUrl} 
                                        alt={tech.name}
                                        className="w-8 h-8 transition-transform duration-300 group-hover:scale-110"
                                    />
                                )}
                                <span className="text-sm font-medium text-slate-700 dark:text-slate-300 text-center leading-tight transition-colors duration-300">
                                    {tech.name}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
                
                {(!tags || tags.length === 0) && (
                    <div className="text-center py-8">
                        <div className="w-16 h-16 bg-slate-100 dark:bg-slate-900 rounded-full flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                            <svg className="w-8 h-8 text-slate-400 dark:text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                            </svg>
                        </div>
                        <p className="text-slate-500 dark:text-slate-400 font-medium transition-colors duration-300">No technologies specified</p>
                    </div>
                )}
            </div>
        </div>
    )
}
export default TechnologiesUsed;
